import { Helmet } from "react-helmet";
import { Container } from "reactstrap";

import { PageTitles } from "../../../constants";

import EditContent from "./EditContent";

export default function EditContentDetails() {
    return (
        <div className="page-content">
            <Helmet>
                <title>{PageTitles.EDIT_CONTENT_LIBRARY_ITEM}</title>
            </Helmet>
            <Container fluid className="customer-details">
                <EditContent />
            </Container>
        </div>
    );
}
